import { useEffect, useState } from 'react'

function detect(): boolean {
  if (typeof window === 'undefined') return false
  const params = new URLSearchParams(window.location.search)
  if (params.get('cai_embed') !== '1') return false
  return window.parent !== window
}

export function useIsEmbedded(): boolean {
  const [embedded, setEmbedded] = useState(detect)
  useEffect(() => {
    setEmbedded(detect())
  }, [])
  return embedded
}
